import React from "react";

export default function HeaderTigaJumbotron() {
  return (
    <div className="container flex justify-center items-center custom-bg-about">
      <div className="text-center">
        <h5 className="text-6xl font-bold text-lime-400">Header 3</h5>

        <p className="text-xl text-white mt-5">
          <span className="text-white mr-10">Home</span>/
          <span className="text-white mx-10">Feature</span>/
          <span className="text-lime-400 font-bold ml-10">Header 3</span>
        </p>
      </div>
    </div>
  );
}
